import { styleguideColors as COLORS } from '@/Client/Styles/kaiShikiTokens';
import { css, SerializedStyles } from '@emotion/react';

export type NeedsAttentionIndicatorStyles = {
  root: SerializedStyles;
  /** Layered on top of `root` when the indicator reads as flagged. */
  active: SerializedStyles;
};

export const DEFAULT_NEEDS_ATTENTION_INDICATOR_STYLES: NeedsAttentionIndicatorStyles = {
  root: css`
    label: NEEDS_ATTENTION_INDICATOR;
    display: inline-flex;
    flex-shrink: 0;
  `,
  active: css`
    label: NEEDS_ATTENTION_INDICATOR_ACTIVE;
    color: ${COLORS.error};
  `,
};
